import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as UIC from '@dds-uicore/all';
import { Masthead } from '@dds-uicore/all';
import { AuthService } from '../shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from '../shared/global-constants';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  fullName: any;
  RoleName:string;
  FirstName:string;
  EmailAddress:string;
  dloUrl=environment.dloLoginUrl;
  GuestUser= GlobalConstants.GuestUser;
  processingLogin: boolean;
  constructor(private authService:AuthService,private router:Router,private route: ActivatedRoute) { }
  searchQuery(form:NgForm){
  }
  ngOnInit(): void {
    this.processingLogin=true;
    setTimeout(() => {
      this.route.queryParams.subscribe((params: any) => {
        if (Object.keys(params).length) { //params like accessToken and expiresIn
          this.processingLogin=true;
        }
        else
          this.processingLogin=false;
      })
    }, 10);//A dealy of 10ms is provided to counter the unexpected behaviour of ActivatedRoute subscription with the hidden attribute in html page

    this.authService.itemValue.subscribe((nextValue) => {
        this.FirstName=(!nextValue.FirstName  || typeof nextValue.FirstName  === 'undefined' || nextValue.FirstName  === "undefined")?'Guest':nextValue.FirstName;
        this.RoleName=nextValue.RoleName;
        this.EmailAddress=nextValue.EmailAddress;

   });


    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__modal\"]"), function(element) {
      new UIC.Modal(element, {
          backdrop: 'static'
      });
    });

    const mastheadElement = document.querySelectorAll('[data-toggle=\"dds__msthd\"]');
    new Masthead(mastheadElement[0]);

  }

  logout(){
    this.authService.logout();
    this.authService.destroyUserSession();
    window.location.href = environment.dloLoginUrl;

    const source = localStorage.getItem('source');
    if(source =='help') {
      window.close();
    }
  }

}
